module.exports = __webpack_public_path__ + "img/banner.a6c06848.png";